const toCamel = (string: string): string => {
  return string.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};

export const toCamelCase = <T>(obj: unknown): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    const len = obj.length;
    const arr = new Array(len);

    for (let i = 0; i < len; i++) {
      arr[i] = toCamelCase(obj[i]);
    }

    return arr as unknown as T;
  }

  const result: Record<string, unknown> = {};
  const keys = Object.keys(obj as Record<string, unknown>);
  const len = keys.length;

  for (let i = 0; i < len; i++) {
    const key = keys[i];
    result[toCamel(key)] = toCamelCase((obj as Record<string, unknown>)[key]);
  }

  return result as unknown as T;
};
